import React from 'react';
import { Row, Col } from 'react-bootstrap';
import ReactEChartsCore from '../EChart';
import * as echarts from 'echarts/core';
import { useAppContext } from '../../../providers/AppProvider';
import { TooltipComponent } from 'echarts/components';
import { PieChart } from 'echarts/charts';

echarts.use([TooltipComponent, PieChart]);

const getRandomPercentage = () => Math.floor(Math.random() * 30) + 10; // Generate random percentages for slices

const getDefaultOptions = getThemeColor => ({
  color: [
    getThemeColor('info-300'),
    getThemeColor('warning-300'),
    getThemeColor('danger-300'),
    getThemeColor('success-300'),
    getThemeColor('primary')
  ],
  tooltip: {
    trigger: 'item',
    formatter: '{d}%' // Display slice name and percentage
  },
  series: [
    {
      name: 'Copper quantity needed',
      type: 'pie',
      radius: ['48%', '90%'],
      startAngle: 30,
      avoidLabelOverlap: true, // Prevent overlapping labels
      label: {
        show: true, // Enable labels on slices
        position: 'inside', // Place labels outside slices
        formatter: '{d}%', // Show slice name and percentage
        fontSize: 12,
        fontWeight: 600,
        color: getThemeColor('gray-700')
      },
      emphasis: {
        label: {
          show: true,
          fontSize: 14, // Increase font size on hover
          fontWeight: 'bold'
        }
      },
      labelLine: {
        show: true, // Show lines connecting labels to slices
        length: 10,
        length2: 15
      },
      data: [
        { value: getRandomPercentage(), name: 'Solid Copper 1.35' },
        { value: getRandomPercentage(), name: 'Solid Copper 1.70' },
        { value: getRandomPercentage(), name: 'Solid Copper 2.14' }
      ]
    }
  ],
  grid: {
    bottom: 0,
    top: 0,
    left: 0,
    right: 0,
    containLabel: false
  }
});

const CircleProductionTvChart = () => {
  const { getThemeColor } = useAppContext();

  return (
    <Row className="g-3 mb-3">
      <Col xs={12} md={6}>
        <h3 className="text-1100 text-nowrap">Copper Discovered</h3>
        <p className="text-700 mb-md-7">Newly found and yet to be solved</p>
        <div className="d-flex align-items-center justify-content-between">
          <p className="mb-0 fw-bold">Issue type </p>
        </div>
        <hr className="bg-200 mb-2 mt-2" />

        <div className="d-flex align-items-center mb-1">
          <span className={`d-inline-block bg-green bullet-item me-2`} />
          <p className="mb-0 fw-semi-bold text-900 lh-sm flex-1">RUS IACOB</p>
          <h5 className="mb-0 text-900">32 %</h5>
        </div>
        <div className="d-flex align-items-center mb-1">
          <span className={`d-inline-block bg-green bullet-item me-2`} />
          <p className="mb-0 fw-semi-bold text-900 lh-sm flex-1">VALER SOT</p>
          <h5 className="mb-0 text-900">32 %</h5>
        </div>
        <div className="d-flex align-items-center mb-1">
          <span className={`d-inline-block bg-green bullet-item me-2`} />
          <p className="mb-0 fw-semi-bold text-900 lh-sm flex-1">
            ANGHEL VASILE{' '}
          </p>
          <h5 className="mb-0 text-900">32 %</h5>
        </div>
      </Col>
      <Col xs={12} md={6}>
        <div className="position-relative mb-sm-4 mb-xl-0">
          <ReactEChartsCore
            echarts={echarts}
            option={getDefaultOptions(getThemeColor)}
            style={{ minHeight: '390px', width: '100%' }}
          />
        </div>
      </Col>
    </Row>
  );
};

export default CircleProductionTvChart;
